import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

interface IProps {
    show: boolean
    onHide: () => void
}

/* not used */
function AccessModal(props:IProps) {

    const navigate = useNavigate();

    return (
        <Modal show={props.show} onHide={props.onHide} className="access-modal">
            <Modal.Header closeButton>
                Locked
            </Modal.Header>
            <Modal.Body>
                <p>Subscribe to access</p>
                <p className="info-text">This page is available to Subscription users only</p>
                <Button className="default-button" onClick={() => navigate("/dashboard/account/subscription/buy")}>View Subscriptions</Button>
            </Modal.Body>
        </Modal>
    )
}

export default AccessModal;